export default class FormSubmitToggle {
  constructor(formId, disableBtn) {
    this.$context = $(formId);
    this.$requiredInputs = this.$context.find('input').filter('[required]');
    this.$submitBtn = this.$context.find('input[type=submit]');
    this.disableBtn = disableBtn;

    this.bind();
  }

  bind() {
    if (this.disableBtn) {
      this.handleSubmitBtn();

      this.$context.on('change', () => this.handleSubmitBtn());
    }

    this.$context.on('submit', e => this.beforeSubmit(e));
  }

  handleSubmitBtn() {
    if (this.fieldsAreNotValid()) {
      this.disableSubmit();
    } else {
      this.enableSubmit();
    }
  }

  beforeSubmit(e) {
    if (this.fieldsAreNotValid()) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  enableSubmit() {
    this.$submitBtn.removeClass('disabled');
  }

  disableSubmit() {
    this.$submitBtn.addClass('disabled');
  }

  fieldsAreNotValid() {
    const invalidInputs = this.$requiredInputs.filter(function () {
      return this.checkValidity() === false;
    });

    return invalidInputs.length === 0 ? false : true;
  }
}
